import React from 'react';
import SignUpWelcomeFom from '../../../form/SignUpWelcomeFom/SignUpWelcomeFom';
import { useDispatch } from 'react-redux';
import { Form as FinalForm, Field } from 'react-final-form';
import { Form, PrimaryButton, ResponsiveImage } from '../../../components';

import css from './../../../form/SignUpWelcomeFom/SignUpWelcomeFom.module.css';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { joinSpace, leaveSpace } from '../CircleCommunityPage.duck';

const SelectSpaceComponent = props => {
  return (
    <FinalForm
      {...props}
      keepDirtyOnReinitialize={true}
      //   mutators={{ ...arrayMutators }}
      render={fieldRenderProps => {
        const {
          rootClassName,
          className,
          handleSubmit,
          inProgress,
          invalid,
          spaceListData,
        } = fieldRenderProps;

        const dispatch = useDispatch();
        const classes = classNames(rootClassName || css.root, className);
        const submitInProgress = inProgress;
        const submitDisabled = invalid || submitInProgress;

        const handleJoinGroup = (spaceId, isSelected) => {
          console.log('isSelected', !isSelected);
          if (!isSelected) {
            dispatch(joinSpace(spaceId));
          } else {
            dispatch(leaveSpace(spaceId));
          }
        };

        const totalJoinedGroups = spaceListData?.filter(item => item.is_member).length;
        if (!spaceListData || (spaceListData && spaceListData.length == 0)) {
          return <></>;
        }

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            <div className={css.welcomeHeading}>
              <FormattedMessage
                id={"CircleFeedPage.joinGroupMessage"}
                values={{ count: (3 - totalJoinedGroups) }}
              />
            </div>
            {/* <div className={css.welcomeTitle}>
              <FormattedMessage id="CommunityFeed.joinGroupsSubtitle" />
            </div> */}

            <div className={css.userCheckBox}>
              {spaceListData
                ?.filter(group => !group.is_private)
                ?.map(group => (
                  <Field key={group.id} name="selectedGroups" type="checkbox" value={group.id}>
                    {({ input }) => (
                      <div
                        className={
                          group.is_member || input.checked
                            ? css.activeCheckbox
                            : css.inactiveCheckbox
                        }
                        onClick={() => handleJoinGroup(group.id, input.checked)}
                      >
                        <div>
                          <input {...input} id={`group-${group.id}`} type="checkbox" />
                          <label htmlFor={`group-${group.id}`}>
                            {group?.cover_image_url ? (
                              <ResponsiveImage
                                imagewithURL={group?.cover_image_url}
                                alt={group.name}
                                className="group-image"
                              />
                            ) : null}
                          </label>
                        </div>
                        <label htmlFor={`group-${group.id}`}>
                          <div className={css.grouplabel}>{group.name}</div>
                          <div className={css.groupSubTitle}>{group?.subTitle}</div>
                        </label>
                      </div>
                    )}
                  </Field>
                ))}
            </div>

            <div className={css.bottomWrapper}>
              <PrimaryButton type="submit" inProgress={submitInProgress} disabled={submitDisabled}>
                <FormattedMessage id={"CommunityFeed.exploreButton"} />
              </PrimaryButton>
            </div>
          </Form>
        );
      }}
    />
  );
};
export default SelectSpaceComponent;
